<div id="modalrooms" style="position: relative">
  <div id="modalRooms">
    <div class="modal-content" style="padding-bottom: 50px; padding: 3em 2.5em; position: relative">
      <div class="d-flex justify-content-between mx-auto" style="width: 98%">
        <p
          class="title mb-0 mt-2 pr-5"
          style="
            font-family: &quot;Rubik&quot;, sans-ferif;
            font-size: 30px;
            font-weight: 400;
            line-height: 1 !important;
            color: #3f3f3f !important;
          "
        >
          {{ result?.title }}
        </p>

        <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
          <span aria-hidden="true" style="font-size: 60px; font-weight: 100">&times;</span>
        </button>
      </div>

      <div
        *ngIf="action && action !== 'comments'"
        class="d-flex my-3 justify-content-between"
        style="background-color: #fcfcfc; border: 1px solid #ececec; border-radius: 6px"
      >
        <button
          *ngIf="quote"
          class="btn-tabs w-100"
          [ngStyle]="{
            color: tab === 'INCLUDES' ? buttonColorActive : buttonTextActive
          }"
          style="border-right: 1px solid #ececec"
          (click)="tab = 'INCLUDES'"
        >
          PLAN
        </button>
        <button
          class="btn-tabs w-100"
          [ngStyle]="{
            color: tab === 'INFO' ? buttonColorActive : buttonTextActive
          }"
          style="border-right: 1px solid #ececec"
          (click)="tab = 'INFO'"
        >
          INFO
        </button>
        <button
          class="btn-tabs w-100"
          [ngStyle]="{
            color: tab === 'comments' ? buttonColorActive : buttonTextActive
          }"
          (click)="tab = 'comments'"
        >
          COMENTARIOS
        </button>
      </div>

      <div class="d-flex align-items-start mb-2 pt-2 pb-4" style="margin-left: 0.75rem; margin-right: 0.75rem">
        <div class="d-flex flex-column" style="max-width: 195px; width: 100%; padding-top: 30px;">
          <p class="usb-modal-text--subtitle semi-bold" style="margin-bottom: 10px">Tipo de Vehículo</p>
          <p class="mb-0 usb-modal-text--subtitle" style="max-width: 120px;">{{ result.title }}</p>
        </div>

        <div class="d-flex flex-row justify-content-between" style="gap: 1.5em; width: 65%; padding-top: 30px; padding-left: 20px; padding-right: 20px;">
          <div class="d-flex flex-column align-items-start" style="gap: 1.2em">

            <!-- PAX -->
            <div class="d-flex align-items-center justify-content-center" style="gap: 0.35em; margin-right: 1.9em">
              <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color: black; font-family: 'Poppins' !important; font-size: 16px !important;">
                {{ result?.additionalInfo?.carRental?.paxQuantity ? result?.additionalInfo?.carRental?.paxQuantity : 0 }}
              </p>
              <div class="d-flex align-items-center justify-content-center" style="width: 30px; height: 30px;">
                <img src="../../../../../assets/icons/search-result/persona.svg" width="30px" height="30px" alt="" />
              </div>
              <div class="d-flex flex-column justify-content-center" style="border-left: 1px solid #b9b9b9; min-height: 32px;">
                <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em">Pax</p>
              </div>
            </div>

            <!-- Doors -->
            <div class="d-flex align-items-center justify-content-end" style="gap: 0.35em">
              <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color: black; font-family: 'Poppins' !important; font-size: 16px !important;">
                {{ result?.additionalInfo?.carRental?.doors ? result?.additionalInfo?.carRental?.doors : 0 }}
              </p>
              <div class="d-flex align-items-center justify-content-center" style="width: 30px; height: 30px;">
                <img src="../../../../../assets/icons/search-result/puerta de auto.svg" width="30px" height="30px" alt="" />
              </div>
              <div class="d-flex flex-column justify-content-center" style="border-left: 1px solid #b9b9b9; min-height: 32px;">
                <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em">Puertas</p>
              </div>
            </div>
          </div>

          <!-- Bag -->
          <div class="d-flex flex-column" style="gap: 1em">
            <div class="d-flex align-items-center" style="gap: 0.25em">
              <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color: black; font-family: 'Poppins' !important; font-size: 16px !important;">
                {{ result?.additionalInfo?.carRental?.bagsQuantity ? result?.additionalInfo?.carRental?.bagsQuantity : 0 }}
              </p>
              <div class="d-flex align-items-center justify-content-center" style="width: 30px; height: 30px;">
                <img src="../../../../../assets/icons/search-result/carry.svg" width="30px" height="30px" alt="" />
              </div>
              <div class="d-flex flex-column justify-content-center" style="border-left: 1px solid #b9b9b9; min-height: 32px;">
                <p class="usb-modal-text--body mb-0" style="padding-left: 0.6em">Maletas</p>
              </div>
            </div>
          </div>

          <div
            class="d-flex flex-column justify-content-center px-3"
            style="gap: 0.5em; border: 1.5px solid #bfbfbf; border-radius: 10px; min-width: 135px; height: 75px;"
          >
            <div class="d-flex align-items-center" style="gap: 0.5em">
              <img src="../../../../../assets/icons/search-result/caja automática 02.svg" width="22px" height="22px" alt="" />
              <p class="usb-modal-text--body mb-0">
                {{ result?.additionalInfo?.carRental?.gearbox === "Automático" ? "Automática" : "Manual" }}
              </p>
            </div>
            <div class="d-flex align-items-center" style="gap: 0.5em">
              <img src="../../../../../assets/icons/search-result/aire acondicionado 02.svg" width="22px" height="22px" alt="" />
              <p class="usb-modal-text--body mb-0">
                {{ result?.additionalInfo?.carRental?.fuel_aircondition === "Con Aire Acondicionado" ? "Aire" : "Sin Aire" }}
              </p>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center">
          <img
            src="{{ result.additionalInfo.images[0].thumbnail }}"
            width="auto"
            height="auto"
            alt=""
            style="background-size: cover; width: 180px; object-fit: cover;"
          />
        </div>
      </div>

      <div class="modal-body pt-0 px-0" style="position: relative">
        <div class="row m-0">
          <div class="content-modal mt-2" style="width: 100%">
            <!-- INCLUDES -->
            <ng-container *ngIf="quote">
              <div [ngClass]="{ 'd-block': tab == 'INCLUDES', 'd-none': tab != 'INCLUDES' }">
                <div class="row d-flex pb-3 m-0">
                  <div class="d-flex w-100" style="height: auto; gap: 10px">
                    <div class="d-flex flex-column w-50 p-4" style="border: 1px solid #e7e7e7">
                      <div class="d-flex flex-column" style="line-height: 1.2; gap: 1px; margin-bottom: 15px">
                        <div class="w-100">
                          <p class="usb-modal-text--body-strong rubik m-0">Fecha de Retiro</p>
                        </div>
                        <div class="w-100">
                          <p class="usb-modal-text--body light m-0">
                            {{ dateIni }}
                          </p>
                        </div>
                        <div class="w-100">
                          <p class="usb-modal-text--body light m-0">{{ timeIni }} hs</p>
                        </div>
                      </div>

                      <div class="d-flex flex-column pt-2" style="border-top: 1px solid #e7e7e7">
                        <div class="d-flex flex-row w-100" style="margin-top: 10px; margin-bottom: 15px;">
                          <div class="w-100 h-25">
                            <p class="usb-modal-text--body-strong m-0">Oficina de retiro</p>
                          </div>
                          <div class="w-100 h-25 d-flex justify-content-end">
                            <button class="usb-modal-text--body button-map" (click)="openMap('pickup')">Ver Mapa</button>
                          </div>
                        </div>
                        <div class="w-100 h-25" style="position: relative">
                          <select
                            class="form-control usb-modal-text--body"
                            (change)="onChangePickup($event.target.value)"
                            style="
                              height: 38px !important;
                              width: 100%;
                              text-align: left !important;
                              padding-left: 30px !important;
                              font-size: 13px;
                            "
                          >
                            <option value="null" selected disabled>Seleccione una Oficina</option>
                            <ng-container *ngFor="let location of getOfficesPickup(result); let index = index">
                              <option value="{{ location | json }}">{{ location?.Name }} ({{ location?.Address }})</option>
                            </ng-container>
                          </select>
                          <img
                            class="icon-fly"
                            src="../../../../../assets/icons/search-result/ICONO FLY.svg"
                            width="15px"
                            height="15px"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-column w-50 p-4" style="border: 1px solid #e7e7e7">
                      <div class="d-flex flex-column" style="line-height: 1.2; gap: 1px; margin-bottom: 15px">
                        <div class="w-100">
                          <p class="usb-modal-text--body-strong rubik m-0" style="font-size: 12px">Fecha de Devolución</p>
                        </div>
                        <div class="w-100">
                          <p class="usb-modal-text--body m-0">
                            {{ dateEnd }}
                          </p>
                        </div>
                        <div class="w-100">
                          <p class="usb-modal-text--body m-0">{{ timeEnd }} hs</p>
                        </div>
                      </div>

                      <div class="d-flex flex-column pt-2" style="border-top: 1px solid #e7e7e7">
                        <div class="d-flex flex-row w-100" style="margin-top: 10px; margin-bottom: 15px;">
                          <div class="w-100 h-25">
                            <p class="usb-modal-text--body-strong m-0">Oficina de devolución</p>
                          </div>

                          <div class="w-100 h-25 d-flex justify-content-end">
                            <button class="usb-modal-text--body button-map" (click)="openMap('dropoff')">
                              Ver Mapa
                            </button>
                          </div>
                        </div>
                        <div class="w-100 h-25" style="position: relative">
                          <select
                            class="form-control usb-modal-text--body"
                            (change)="onChangeDropOff($event.target.value)"
                            style="
                              height: 38px !important;
                              width: 100%;
                              text-align: left !important;
                              padding-left: 30px !important;
                              font-size: 13px;
                            "
                          >
                            <option value="null" selected disabled>Seleccione una Oficina</option>
                            <ng-container *ngFor="let location of getOfficesDropoff(result); let index = index">
                              <option value="{{ location | json }}">{{ location?.Name }} ({{ location?.Address }})</option>
                            </ng-container>
                          </select>
                          <img
                            class="icon-fly"
                            src="../../../../../assets/icons/search-result/ICONO FLY.svg"
                            width="15px"
                            height="15px"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="(openMapPickup || openMapDropoff) && tab == 'INCLUDES'" class="d-flex">
                  <div class="p-4" style="width: 100%; height: 400px; border: 1px solid #e7e7e7;">
                    <app-map-view
                      [coordinatesArr]="openMapPickup ? selectedPickup : selectedDropOff"
                      [pickupData]="pickupLocation"
                      [dropoffData]="dropoffLocation"
                      [currencyAgency]="currencyAgency"
                      [mapHeight]="'350px'"
                      [currencies]="currencies"
                      mapMode="transfer"
                    >
                    </app-map-view>
                  </div>
                </div>

                <div class="row m-0">
                  <div
                    *ngFor="let includes of arrayResults; let index = index; let last = last"
                    class="col-12 includes-detail mt-3"
                    [ngStyle]="{ 'margin-bottom': last ? '140px' : '15px' }"
                  >
                    <div class="row m-0" id="{{ index }}">
                      <div class="include-list py-3 px-1" style="padding-top: 40px !important;">
                        <h4 class="usb-modal-text--subtitle semi-bold" style="text-transform: capitalize; margin-bottom: 20px;">
                          {{ namePlan(includes?.additionalInfo?.carRental?.optionRates?.plan.description) }}
                        </h4>

                        <div class="row mx-0 mt-2 mb-4 pr-3">
                          <div class="col pr-0 pl-0">
                            <p class="usb-modal-text--body-strong mb-1">Incluye</p>

                            <ng-container *ngIf="insuranceRentacar(includes).length > 0">
                              <ng-container *ngFor="let include of insuranceRentacar(includes)">
                                <div class="d-flex flex-row align-items-start mb-1" style="gap: 10px">
                                  <i class="bi bi-check" style="line-height: 1; color: black; font-size: 1.5em"></i>
                                  <div class="d-flex flex-column">
                                    <p
                                      class="mb-0 usb-modal-text--body"
                                      style="
                                        margin-top: 6px;
                                      "
                                    >
                                      {{ include.Name }}
                                    </p>
                                    <p class="mb-0 usb-modal-text--body">
                                      {{ include.Description ? include.Description : "" }}
                                    </p>
                                  </div>
                                </div>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="insuranceRentacar(includes).length === 0">
                              <p
                                class="mb-0 usb-modal-text--body"
                                style="
                                  margin-top: 6px;
                                "
                              >
                                N/A
                              </p>
                            </ng-container>
                          </div>
                          <div class="col pr-0 pl-0">
                            <p class="usb-modal-text--body-strong mb-1">No incluye</p>

                            <ng-container *ngIf="insuranceRentacarNoIncluded(includes).length > 0">
                              <ng-container *ngFor="let include of insuranceRentacarNoIncluded(includes)">
                                <div class="d-flex flex-row align-items-start mb-1">
                                  <i class="bi bi-check" style="line-height: 1; color: black; font-size: 1.5em"></i>
                                  <div class="d-flex flex-column">
                                    <p
                                      class="mb-0 usb-modal-text--body"
                                      style="
                                        margin-top: 6px;
                                      "
                                    >
                                      {{ include.Name }}
                                    </p>
                                    <p class="mb-0 usb-modal-text--body">
                                      {{ include.Description ? include.Description : "" }}
                                    </p>
                                  </div>
                                </div>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="insuranceRentacarNoIncluded(includes).length === 0">
                              <p
                                class="mb-0 usb-modal-text--body"
                                style="
                                  margin-top: 6px;
                                "
                              >
                                N/A
                              </p>
                            </ng-container>
                          </div>
                        </div>

                        <!--  -->
                        <div class="d-flex flex-column pl-2 mt-2">
                          <span
                            *ngIf="includes?.optionalMandatoryRentacarArray && includes?.optionalMandatoryRentacarArray.length > 0"
                            class="usb-modal-text--body-strong mt-2 mb-3"
                            >Obligatorios</span
                          >

                          <ng-container *ngFor="let optional of includes?.optionalMandatoryRentacarArray; let i = index">
                            <div class="d-flex align-items-start w-100 mb-4 justify-content-between" style="gap: 1em">
                              <div class="d-flex align-items-start">
                                <div style="width: 15px; height: 15px">
                                  <input class="w-100 h-100" type="checkbox" class="checkbox-optional" [checked]="true" />
                                </div>
                                <div class="d-flex flex-column">
                                  <p class="mb-0 usb-modal-text--body ml-2">
                                    {{ optional.Name }}
                                  </p>
                                </div>
                              </div>
                              <div
                                class="d-flex flex-row justify-content-around mb-0 align-items-start usb-modal-text--body"
                                style="width: 60%;"
                              >
                                <span class="w-100">
                                  (<span style="font-weight: 500">{{ currencyAgency.code }}</span>
                                  {{
                                    optional.totalNetPriceProf
                                      | currencyConverterPure: result.additionalInfo.carRental.currency : currencyAgency?.code : currencies
                                      | number: "1.2-2"
                                  }}
                                  pago único)
                                </span>
                              </div>
                            </div>
                          </ng-container>

                          <span
                            *ngIf="includes?.optionalRentacarArray && includes?.optionalRentacarArray.length > 0"
                            class="usb-modal-text--body-strong mt-2 mb-3"
                            >Opcionales</span
                          >
                          <ng-container *ngFor="let optional of includes?.optionalRentacarArray; let i = index">
                            <div class="d-flex align-items-start w-100 mb-4 justify-content-between" style="gap: 1em">
                              <div class="d-flex align-items-start" style="width: 100%">
                                <input type="checkbox" class="checkbox-optional" (change)="optionalSelected($event, optional, includes)" />
                                <div class="d-flex flex-column">
                                  <p class="mb-0 usb-modal-text--body ml-2" style="line-height: 1">
                                    {{ optional.Name }}
                                  </p>
                                  <p
                                    class="mb-0 font-template ml-2"
                                    style="margin-top: 3px; font-weight: 600; color: black"
                                  >
                                    (Sujeto a disponibilidad)
                                  </p>
                                </div>
                              </div>
                              <div
                                class="d-flex flex-row justify-content-around mb-0 align-items-start usb-modal-text--body"
                                style="width: 60%;"
                              >
                                <span class="w-100">
                                  (<span style="font-weight: 500">{{ currencyAgency.code }}</span>
                                  {{
                                    optional.totalNetPriceProf
                                      | currencyConverterPure: result.additionalInfo.carRental.currency : currencyAgency?.code : currencies
                                      | number: "1.2-2"
                                  }})
                                </span>
                                <button
                                  type="button"
                                  class="button-optional mt-1"
                                  style="font-weight: bold"
                                  (click)="decrementOptional(optional, includes)"
                                  [disabled]="optional.disabledQty"
                                >
                                  -
                                </button>
                                <input
                                  type="number"
                                  min="0"
                                  max="5"
                                  [(ngModel)]="optional.qtyOptional"
                                  [disabled]="optional.disabledQty"
                                  class="qty-disabled text-center"
                                  style="width: 50px; height: 31px; border: 1px solid #7e7e7e; border-radius: 5px"
                                />
                                <button
                                  type="button"
                                  class="button-optional mt-1"
                                  style="font-weight: bold"
                                  (click)="incrementOptional(optional, includes)"
                                  [disabled]="optional.disabledQty"
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          </ng-container>
                        </div>

                        <div class="my-3">
                          <usb-accordion-info-product
                            #accordionComponent
                            [items]="accordionItemsData"
                            [config]="accordionConfigData"
                            [categoryId]="2"
                            (itemToggle)="onAccordionToggle($event)"
                          >
                            <ng-template #accordionContent let-item let-index="index">
                              <ng-container [ngSwitch]="item.id">
                                <!-- Descripción -->
                                <div *ngSwitchCase="'requirements'">
                                  <p
                                    class="mb-0 usb-modal-text--body"
                                    [innerHTML]="requirementsData"
                                    *ngIf="requirementsData; else noDesc"
                                  ></p>
                                  <ng-template #noDesc>
                                    <p class="text-muted">No hay requisitos disponible</p>
                                  </ng-template>
                                </div>

                                <!-- Políticas de Cancelación -->
                                <div *ngSwitchCase="'policies'">
                                  <usb-cancellation-policies
                                    class="accordion-item-policies"
                                    #politicsSection
                                    [cancellationPolicies]="cancellationData"
                                    [currencies]="currencies"
                                    [currencyAgency]="currencyAgency"
                                    [categoryId]="2"
                                    [rentacarLayout]="true"
                                  >
                                  </usb-cancellation-policies>
                                </div>
                              </ng-container>
                            </ng-template>
                          </usb-accordion-info-product>
                        </div>
                      </div>

                      <div class="select-include-list d-flex flex-column p-4" style="border-left: solid 1px #e3e3e3">
                        <div class="d-flex flex-column w-auto p-3" style="line-height: 19px">
                          <span class="font-text-rubik" style="font-weight: bold; line-height: 1.2; font-size: 14.94px">Tarifa Total</span>
                          <span class="font-rubik w-100" style="font-weight: 600; width: 132px; font-size: 18px; line-height: 1.2"
                            >{{ currencyAgency.code }}
                            {{
                              includes?.additionalInfo?.carRental?.totalPriceProf
                                | currencyConverterPure: includes.additionalInfo.carRental.currency : currencyAgency?.code : currencies
                                | number: "1.2-2"
                            }}</span
                          >
                          <span class="font-text-rubik" style="font-weight: bold; line-height: 1.2; font-size: 16px"
                            >{{ includes?.additionalInfo?.carRental?.currency }}
                            {{ includes?.additionalInfo?.carRental?.netPriceProf | number: "1.2-2" }}</span
                          >
                          <span class="font-text-rubik" style="font-size: 12px; line-height: 1">Imp. Incluidos</span>
                        </div>

                        <hr class="w-100" style="border: none; border-bottom: 1px dashed #ababab" />

                        <div class="d-flex flex-column w-auto p-3 mb-2" style="line-height: 19px">
                          <!-- Tarifa neta -->
                          <div class="mb-2 d-flex flex-column">
                            <span class="font-text-rubik mb-0" style="font-size: 14px !important; font-weight: 500; line-height: 1.2"
                              >Tarifa Neta</span
                            >
                            <span
                              class="font-rubik w-100 mb-0"
                              style="font-size: 14px !important; font-weight: 400; width: 132px; line-height: 1.2"
                              >{{ currencyAgency.code }}
                              {{
                                includes?.additionalInfo?.carRental?.netPriceProf -
                                  getPriceAddons(includes?.additionalInfo?.carRental?.addonsIncluded)
                                  | currencyConverterPure: includes.additionalInfo.carRental.currency : currencyAgency?.code : currencies
                                  | number: "1.2-2"
                              }}</span
                            >
                            <span
                              class="font-rubik w-100"
                              style="font-size: 14px !important; font-weight: 400; width: 132px; line-height: 1.2"
                            >
                              {{ includes?.additionalInfo?.carRental?.currency }}
                              {{
                                includes?.additionalInfo?.carRental?.netPriceProf -
                                  getPriceAddons(includes?.additionalInfo?.carRental?.addonsIncluded) | number: "1.2-2"
                              }}
                            </span>
                            <span class="font-text-rubik mb-2" style="font-size: 11px; line-height: 1">Imp. Incluidos</span>
                          </div>

                          <!-- Tarifa a pagar en destino -->
                          <div class="d-flex flex-column">
                            <span class="font-text-rubik mb-0" style="font-size: 14px !important; font-weight: 500; line-height: 1.2"
                              >Tarifa a pagar en destino</span
                            >
                            <span
                              class="font-rubik w-100 mb-0"
                              style="font-size: 14px !important; font-weight: 400; width: 132px; line-height: 1.2"
                            >
                              {{ currencyAgency.code }}
                              {{
                                getPriceAddons(includes?.additionalInfo?.carRental?.addonsIncluded)
                                  | currencyConverterPure: includes.additionalInfo.carRental.currency : currencyAgency?.code : currencies
                                  | number: "1.2-2"
                              }}
                            </span>
                            <span
                              class="font-rubik w-100 mb-0"
                              style="font-size: 14px !important; font-weight: 400; width: 132px; line-height: 1.2"
                            >
                              {{ includes?.additionalInfo?.carRental?.currency }}
                              {{ getPriceAddons(includes?.additionalInfo?.carRental?.addonsIncluded) | number: "1.2-2" }}
                            </span>
                            <span class="font-text-rubik" style="font-size: 11px; line-height: 1">Imp. Incluidos</span>
                          </div>
                        </div>

                        <div class="d-flex flex-column w-100 px-3 mb-4" *ngIf="includes?.rateClass">
                          <span
                            class="font-text-rubik"
                            style="font-size: 14px !important; font-weight: bold; line-height: 1; color: #5bca90"
                            >Condiciones</span
                          >

                          <div
                            class="d-flex flex-column"
                            *ngIf="includes?.rateClass === 'NR'"
                            style="color: #b70d35; font-size: 12px; line-height: 18px"
                          >
                            <span class="font-text-rubik" style="font-size: 14px !important; line-height: 1">No reembolsable</span>
                            <span class="font-text-rubik" style="font-size: 14px !important; line-height: 1"> 100% tarifa </span>
                          </div>
                          <div class="d-flexncludes?.rateClass === 'R'" style="color: #58c383; font-size: 12px; line-height: 1.2">
                            <span class="font-text-rubik" style="font-size: 14px !important; line-height: 1">Reembolsable Hasta</span>
                            <span
                              *ngIf="
                                includes?.additionalInfo?.carRental?.cancellationPolicies &&
                                includes.additionalInfo?.carRental?.cancellationPolicies.length > 0
                              "
                              class="font-text-rubik"
                              style="font-size: 14px !important; line-height: 1"
                            >
                              {{ getCancellationPolicy(includes?.additionalInfo?.carRental?.cancellationPolicies) | date: "dd/MM/yyyy" }}
                            </span>
                          </div>
                        </div>

                        <div class="content-pago-destino d-flex justify-content-center py-2 m-0">
                          <label class="custom-radio-checkbox m-0 d-flex justify-content-center align-items-center w-100">
                            <p class="font-rubik mb-0" style="font-size: 15px; cursor: pointer; font-weight: 500">SELECCIONAR</p>

                            <!-- radio button hidden -->
                            <span class="d-none align-items-center">
                              <input
                                style="visibility: hidden"
                                class="custom-radio-checkbox__input"
                                id="{{ includes.id }}"
                                value="{{ includes.id }}"
                                name="car"
                                type="radio"
                                (change)="selectCar(includes, index)"
                              />
                              <span class="custom-radio-checkbox__show custom-radio-checkbox__show--radio"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- OPCIONALES       -->

            <!-- INFO -->
            <div [ngClass]="{ 'd-block': tab == 'INFO', 'd-none': tab != 'INFO' }">
              <div class="row d-flex pb-3 m-0">
                <div class="d-flex w-100" style="height: auto; gap: 10px">
                  <div class="d-flex flex-column w-50 p-4" style="border: 1px solid #e7e7e7">
                    <div class="d-flex flex-column" style="line-height: 1.2; gap: 1px; margin-bottom: 15px">
                      <div class="w-100">
                        <p class="usb-modal-text--body-strong rubik m-0">Fecha de Retiro</p>
                      </div>
                      <div class="w-100">
                        <p class="usb-modal-text--body m-0">
                          {{ dateIni }}
                        </p>
                      </div>
                      <div class="w-100">
                        <p class="usb-modal-text--body m-0">{{ timeIni }} hs</p>
                      </div>
                    </div>

                    <div class="d-flex flex-column pt-2" style="border-top: 1px solid #e7e7e7">
                      <div class="d-flex flex-row w-100" style="margin-top: 10px; margin-bottom: 15px;">
                        <div class="w-100 h-25">
                          <p class="usb-modal-text--body-strong mb-2">Oficina de retiro</p>
                        </div>
                        <div class="w-100 h-25 d-flex justify-content-end">
                          <button class="usb-modal-text--body button-map" style="font-size: 12px; font-weight: 400" (click)="openMap('pickup')">
                            Ver Mapa
                          </button>
                        </div>
                      </div>
                      <div class="w-100 h-25" style="position: relative">
                        <p
                          class="mb-0"
                          style="
                            font-family: &quot;Rubik&quot;, sans-serif;
                            font-weight: 400;
                            font-size: 13px;
                            line-height: 1;
                            max-width: 275px;
                          "
                        >
                          {{
                            selectedPickup && selectedPickup.length > 0
                              ? selectedPickup[0].hotel_name
                              : "Seleccione oficina de retiro en plan"
                          }}
                          {{ selectedPickup && selectedPickup.length > 0 ? "(" + selectedPickup[0].address + ")" : "" }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex flex-column w-50 p-4" style="border: 1px solid #e7e7e7">
                    <div class="d-flex flex-column" style="line-height: 1.2; gap: 1px; margin-bottom: 15px">
                      <div class="w-100">
                        <p class="usb-modal-text--body-strong rubik m-0" style="font-size: 12px;">Fecha de Devolución</p>
                      </div>
                      <div class="w-100">
                        <p class="usb-modal-text--body m-0">
                          {{ dateEnd }}
                        </p>
                      </div>
                      <div class="w-100">
                        <p class="usb-modal-text--body m-0">{{ timeEnd }} hs</p>
                      </div>
                    </div>

                    <div class="d-flex flex-column pt-2" style="border-top: 1px solid #e7e7e7">
                      <div class="d-flex flex-row w-100" style="margin-top: 10px; margin-bottom: 15px;">
                        <div class="w-100 h-25">
                          <p class="usb-modal-text--body-strong mb-2">Oficina de devolución</p>
                        </div>
                        <div class="w-100 h-25 d-flex justify-content-end">
                          <button (click)="openMap('dropoff')" class="button-map usb-modal-text--body">
                            Ver Mapa
                          </button>
                        </div>
                      </div>
                      <div class="w-100 h-25" style="position: relative">
                        <p
                          class="mb-0"
                          style="
                            font-family: &quot;Rubik&quot;, sans-serif;
                            font-weight: 400;
                            font-size: 13px;
                            line-height: 1;
                            max-width: 275px;
                          "
                        >
                          {{
                            selectedDropOff && selectedDropOff.length > 0
                              ? selectedDropOff[0].hotel_name
                              : "Seleccione oficina de devolución en plan"
                          }}
                          {{ selectedDropOff && selectedDropOff.length > 0 ? "(" + selectedDropOff[0].address + ")" : "" }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                *ngIf="(openMapPickup || openMapDropoff) && tab == 'INFO'"
                class="d-flex p-4"
                style="border: 1px solid #e7e7e7; margin-bottom: 25px"
              >
                <div style="width: 100%; height: 400px">
                  <app-map-view
                    [coordinatesArr]="openMapPickup ? selectedPickup : selectedDropOff"
                    [currencyAgency]="currencyAgency"
                    [currencies]="currencies"
                    mapMode="general"
                    [mapHeight]="'400px'"
                  >
                  </app-map-view>
                </div>
              </div>

              <div class="row flex-column py-4 mx-0 mb-4" style="background-color: #f9f9f9">
                <div class="d-flex justify-content-between" style="width: 100%; padding: 0px 30px">
                  <div class="d-flex flex-column" style="width: 25%; gap: 30px; padding-left: 20px">
                    <div class="d-flex flex-column">
                      <p class="usb-modal-text--body-strong poppins" style="margin-bottom: 4px;">Retiro:</p>
                      <p class="usb-modal-text--body-strong poppins" style="margin-bottom: 3px;">{{ payload.arrivalDate | date: "dd MMM yyyy" }}</p>
                      <p class="usb-modal-text--body mb-0">{{ timeIni }} hs.</p>
                    </div>
                    <div class="d-flex flex-column">
                      <p class="usb-modal-text--body-strong poppins" style="margin-bottom: 4px;">Devolución:</p>
                      <p class="usb-modal-text--body-strong poppins" style="margin-bottom: 3px;">{{ payload.departureDate | date: "dd MMM yyyy" }}</p>
                      <p class="usb-modal-text--body mb-0">{{ timeEnd }} hs.</p>
                    </div>
                  </div>
                  <div class="d-flex justify-content-around" style="width: 53%">
                    <div *ngIf="quote" class="d-flex flex-column" style="gap: 30px">
                      <div class="d-flex flex-column">
                        <div class="usb-modal-text--body-strong poppins" style="margin-bottom: 4px;">Precio alquiler</div>
                        <div class="d-flex flex-column">
                          <div class="d-flex" style="margin-bottom: 3px;">
                            <p class="usb-modal-text--body-strong poppins mb-0">
                              {{ currencyAgency?.code }}
                              {{
                                result?.additionalInfo?.carRental?.totalPriceProf
                                  | currencyConverterPure: result?.additionalInfo.carRental.currency : currencyAgency.code : currencies
                                  | number: "1.2-2"
                              }}
                            </p>
                            <usb-tooltip-convert-amount
                              [clientsSettingAppBooking]="clientSetting"
                              [currencyProduct]="result?.additionalInfo.carRental.currency"
                              [valueProduct]="result?.additionalInfo?.carRental?.totalPriceProf"
                            ></usb-tooltip-convert-amount>
                          </div>
                          <p class="usb-modal-text--body mb-0">imp. incluídos</p>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <p class="usb-modal-text--body-strong poppins" style="margin-bottom: 4px">
                          Adicionales
                        </p>
                        <div class="d-flex flex-column">
                          <div class="d-flex">
                            <p class="usb-modal-text--body-strong poppins mb-0">
                              {{ currencyAgency?.code }}
                              {{
                                (result.amenitiesIncluded?.length > 0
                                  ? result?.additionalInfo?.carRental?.netPriceBookingWithIncluded -
                                    result?.additionalInfo?.carRental?.totalPriceProf
                                  : 0
                                )
                                  | currencyConverterPure: result?.additionalInfo.carRental.currency : currencyAgency.code : currencies
                                  | number: "1.2-2"
                              }}
                            </p>
                            <usb-tooltip-convert-amount
                              [clientsSettingAppBooking]="clientSetting"
                              [currencyProduct]="result?.additionalInfo.carRental.currency"
                              [valueProduct]="
                                result.amenitiesIncluded?.length > 0
                                  ? result?.additionalInfo?.carRental?.netPriceBookingWithIncluded -
                                    result?.additionalInfo?.carRental?.totalPriceProf
                                  : 0
                              "
                            ></usb-tooltip-convert-amount>
                          </div>
                          <p class="usb-modal-text--body mb-0">imp. incluídos</p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-column justify-content-between" style="gap: 30px">
                      <div class="d-flex align-items-center" style="gap: 13px">
                        <img src="../../../../assets/icons/search-result/duración.svg" width="35px" height="35px" alt="" />

                        <div class="d-flex flex-column" style="padding-top: 5px">
                          <p class="usb-modal-text--body-strong" style="margin-bottom: 4px">Duración:</p>
                          <p class="usb-modal-text--body" style="margin-bottom: 3px">
                            {{
                              getDays(
                                payload.others.carRental.pickupLocation.pickupDate,
                                payload.others.carRental.dropoffLocation.dropoffDate
                              )
                            }}
                            {{
                              getDays(
                                payload.others.carRental.pickupLocation.pickupDate,
                                payload.others.carRental.dropoffLocation.dropoffDate
                              ) > 1
                                ? "días"
                                : "día"
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div>
                          <p class="usb-modal-text--body-strong" style="margin-bottom: 3px">Condiciones</p>
                        </div>
                        <div class="d-flex flex-column">
                          <div class="d-flex flex-column">
                            <span *ngIf="result?.rateClass === 'R'">
                              <div class="d-flex align-items-center">
                                <!-- <i class="bi bi-check line-height" style="font-size: 16px;-webkit-text-stroke: 1.5px;"></i> -->
                                <p
                                  class="usb-modal-text--body-strong light"
                                  style="
                                    margin-bottom: 2px;
                                    color: #69d299;
                                  "
                                >
                                  <img style="width: 17px; height: 17px" src="../../../../assets/icons/search-result/check.svg" alt="" />
                                  REEMBOLSABLE
                                </p>
                              </div>
                              <p
                                class="usb-modal-text--body mb-0"
                                (click)="openPolitics()"
                                style="
                                  cursor: pointer;
                                  color: #69d299;
                                "
                              >
                                hasta: 04/07/2025
                              </p>
                            </span>
                            <span *ngIf="result?.rateClass === 'NR'">
                              <div class="d-flex">
                                <p
                                  class="usb-modal-text--body-strong light"
                                  style="
                                    margin-bottom: 2px;
                                    color: #b70d35;
                                  "
                                >
                                  No Reembolsable
                                </p>
                              </div>
                              <p
                                class="usb-modal-text--body mb-0"
                                style="color: #b70d35"
                              >
                                100% Tarifa
                              </p>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column align-items-center justify-content-center" style="width: 22%">
                    <div>
                      <p class="usb-modal-text--body-strong light" style="margin-bottom: 4px">Tipo de Vehiculo</p>
                      <p class="usb-modal-text--body-strong" style="margin-bottom: 4px">{{ result.additionalInfo?.carRental?.category }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <usb-accordion-info-product
                #accordionComponent
                [items]="accordionItemsData"
                [config]="accordionConfigData"
                [categoryId]="2"
                (itemToggle)="onAccordionToggle($event)"
              >
                <ng-template #accordionContent let-item let-index="index">
                  <ng-container [ngSwitch]="item.id">
                    <!-- Descripción -->
                    <div *ngSwitchCase="'requirements'">
                      <p class="mb-0 usb-modal-text--body" [innerHTML]="requirementsData" *ngIf="requirementsData; else noDesc"></p>
                      <ng-template #noDesc>
                        <p class="text-muted">No hay requisitos disponible</p>
                      </ng-template>
                    </div>

                    <!-- Políticas de Cancelación -->
                    <div *ngSwitchCase="'policies'">
                      <usb-cancellation-policies
                        class="accordion-item-policies"
                        #politicsSection
                        [cancellationPolicies]="cancellationData"
                        [currencies]="currencies"
                        [currencyAgency]="currencyAgency"
                                    [categoryId]="1"
                                  >
                      </usb-cancellation-policies>
                    </div>
                  </ng-container>
                </ng-template>
              </usb-accordion-info-product>
            </div>
          </div>
        </div>

        <!-- COMMENTS -->
        <div [ngClass]="{ 'd-block': tab === 'comments', 'd-none': tab != 'comments' }">
          <ng-container>
            <span *ngIf="tab === 'comments'">
              <usb-comments
                [clientSetting]="clientSetting"
                [payload]="payload"
                [productId]="rentaCar.productId"
                [action]="action"
                (closeModal)="close()"
              >
              </usb-comments>
            </span>
          </ng-container>
        </div>

        <div
          *ngIf="tab == 'INCLUDES' && quote && totalPriceOptional > 0"
          class="d-flex align-items-start mx-auto justify-content-between"
          style="
            height: 160px;
            gap: 1em;
            position: fixed;
            bottom: 0;
            left: 50%;
            transform: translateX(-50.65%);
            width: 100%;
            max-width: 930px;
            border-top: 2px solid #bfbfbf;
            padding: 2em 4em 2em 4em;
            background-color: white;
          "
        >
          <div style="width: 100%">
            <p class="room-selected-title">{{ result?.title }}</p>
          </div>
          <div class="d-flex align-items-start justify-content-end" style="width: 100%; gap: 1em">
            <div class="d-flex flex-column align-items-end justify-content-center">
              <p
                class="mb-0"
                style="
                  font-family: &quot;Rubik&quot;, serif;
                  font-size: 16px;
                  font-weight: 400;
                  line-height: 1;
                  color: #666666;
                  margin-right: 16px;
                "
              >
                Total Tarifa Neta
              </p>
              <div class="d-flex" style="margin-bottom: 15px">
                <p
                  class="mb-0"
                  style="font-family: &quot;Rubik&quot;, serif; font-size: 27px; font-weight: 500; line-height: 1; color: black"
                >
                  {{
                    totalPriceOptional
                      | currencyConverterPure: result.additionalInfo.carRental.currency : currencyAgency?.code : currencies
                      | number: "1.2-2"
                  }}
                </p>
                <usb-tooltip-convert-amount
                  [clientsSettingAppBooking]="clientSetting"
                  [currencyProduct]="itemSelect?.additionalInfo?.carRental?.currency"
                  [valueProduct]="itemSelect?.additionalInfo?.carRental?.totalPrice"
                ></usb-tooltip-convert-amount>
              </div>

              <p
                class="mb-0"
                style="
                  font-family: &quot;Rubik&quot;, serif;
                  font-size: 16px;
                  font-weight: 400;
                  line-height: 1;
                  color: #666666;
                  margin-right: 14px;
                "
              >
                Pagar en destino
              </p>
              <div class="d-flex">
                <p
                  class="mb-0"
                  style="font-family: &quot;Rubik&quot;, serif; font-size: 20px; font-weight: 500; line-height: 1; color: black"
                >
                  {{
                    totalPricePaymentOffice
                      | currencyConverterPure: result.additionalInfo.carRental.currency : currencyAgency?.code : currencies
                      | number: "1.2-2"
                  }}
                </p>
                <usb-tooltip-convert-amount
                  [clientsSettingAppBooking]="clientSetting"
                  [currencyProduct]="itemSelect?.additionalInfo?.carRental?.currency"
                  [valueProduct]="itemSelect?.additionalInfo?.carRental?.totalPrice"
                ></usb-tooltip-convert-amount>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-continue"
              [ngStyle]="{ 'background-color': buttonColorActive, color: buttonTextActive }"
              (click)="add()"
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
